import { makeStyles } from '@material-ui/core/styles'

const usePointrThemedNavbarStyle = makeStyles(() => ({
  appBarRoot: {
    background: 'rgb(255, 255, 255) none repeat scroll 0% 0%'
    // background: 'transparent none repeat scroll 0% 0%'
  },
  appBarRootWithGradiant: {
    background: 'linear-gradient(150.04deg, #230b4c 0%, #1db6fd 100%)',
    height: '90px',
    justifyContent: 'center'
  },
  image: {
    height: '48px'
  },
  menuBar: {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1
  },
  userActionsContainer: {
    flexGrow: 2,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  menuLink: {
    display: 'block',
    padding: '10px 15px',
    fontWeight: 300,
    fontSize: '16px',
    lineHeight: '20px',
    textDecoration: 'none',
    color: 'rgb(69, 18, 149)',
    position: 'relative',
    transition: '0.4s',

    '&:after': {
      transition: '0.2s',
      content: "''",
      position: 'absolute',
      left: '50%',
      right: '10px',
      maxWidth: 0,
      height: '2px',
      backgroundColor: '#f35c00 !important',
      bottom: '8px'
    },

    '&:hover': {
      '&:after': {
        maxWidth: '100%',
        transition: '0.2s',
        left: '10px'
      }
    }
  },
  menuLinkWhite: {
    color: 'rgb(255, 255, 255)'
  },
  hamburgerMenuContainer: {
    marginLeft: 'auto'
  },
  hamburgerMenu: {
    color: 'rgb(69, 18, 149)'
  },
  hamburgerMenuItem: {
    color: 'rgb(69, 18, 149)'
  },
  userActionsButton: {
    borderRadius: 6,
    width: '200px',
    textTransform: 'none',
    fontWeight: 700,
    padding: '8px 30px',
    minWidth: 105
  },
  userActionsMenuItem: {
    width: '200px'
  }
}))

export default usePointrThemedNavbarStyle
